exports = module.exports = require("../../../node_modules/css-loader/lib/css-base.js")();
// imports


// module
exports.push([module.id, "\n.eventEditBody[data-v-ec31fdea] {\n  min-height: 460px;\n}\n.overflow-test[data-v-ec31fdea] {\n  height: 70.9vh;\n  overflow: auto;\n}\n.tab-error-dot[data-v-ec31fdea] {\n  width: 8px;\n  height: 8px;\n  background: #d64545;\n  border-radius: 50%;\n  display: inline-block;\n  margin-left: 8px;\n}\n", ""]);

// exports



//////////////////
// WEBPACK FOOTER
// ./node_modules/css-loader?{"minimize":false,"sourceMap":false}!./node_modules/vue-loader/lib/style-compiler?{"id":"data-v-ec31fdea","scoped":true,"hasInlineConfig":false}!./node_modules/sass-loader/lib/loader.js?{"sourceMap":false}!./node_modules/vue-loader/lib/selector.js?type=styles&index=1!./src/tools/modal/EventEdit.vue
// module id = 1346
// module chunks = 0